import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Group } from '@mantine/core';
import axios from 'axios';
import ApiLinks from '../../Navlinks/ApiLinks';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CustomMantineTable from '../../Utilities/CustomMantineTable';
import { DeleteRecords, EditRecord } from '../../Utilities/EditorDeleteRecords';


function Category() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);


  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/${ApiLinks.Category}/${user.compcode}`)
      .then((response) => {
        if (response.data.status) {
          setData(response.data.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        setLoading(false);
      });

  }, [user.compcode]);



  const columns = [
    {
      id: 'actions',
      header: 'Actions',
      size: '100',
      Cell: ({ row }) => (
        <Group spacing="xs">
          <EditRecord
            id={row.original.id}
            route="/dashboard/categoryadd"
          />
          <DeleteRecords
            id={row.original.id}
            endpoint={`${ApiLinks.Category_Delete}`}
            compcode={user.compcode}
            onDeleteSuccess={(deletedId) =>
              setData((prev) => prev.filter((item) => item.id !== deletedId))
            }
          />
        </Group>
      ),
    },
    {
      accessorKey: 'categoryname',
      header: 'Name',
    },
    {
      accessorKey: 'photo',
      header: 'Photo',
      Cell: ({ cell }) => {
        const photoPath = cell.getValue();
        const imageUrl = `${process.env.REACT_APP_IMG_URL}/${photoPath}`;
        return (
          <a href={imageUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={imageUrl}
              alt="Amenity"
              style={{ width: 'auto', height: '50px', objectFit: 'cover' }}
            />
          </a>
        );
      },
    },

  ];

  return (
    <Box>
      <Group position="apart" mb="md">
        <h2>Category List</h2>
        <Button onClick={() => navigate('/dashboard/categoryadd', { state: { id: null } })}>
          Create
        </Button>
      </Group>
      <Grid justify="center"> 
        <Grid.Col span={6}>
          <CustomMantineTable columns={columns} data={data} loading={loading} />
        </Grid.Col>
      </Grid>
    </Box>

  );
}

export default Category;
